import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllItemSuccess,
  getAllItemFailed,
  GET_ALL_ITEM_START,
} from '../../actions/item'

/**
 * get list item
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListItemApi = (props) => {
  var uri = `/items`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListItem(action) {
  try {
    const response = yield call(getListItemApi, action?.payload)
    yield put(getAllItemSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllItemFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list item
 */
export default function* watchGetListItem() {
  yield takeLatest(GET_ALL_ITEM_START, doGetListItem)
}
